import React, { ReactNode } from 'react';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';

export function FormBody(props: { children: ReactNode }) {
  return <KeyboardAwareScrollView style={{ flex: 1, marginBottom: 10 }}>{props.children}</KeyboardAwareScrollView>;
}
